import { render, staticRenderFns } from "./CurrentResidents.vue?vue&type=template&id=11224718&"
import script from "./CurrentResidents.vue?vue&type=script&lang=js&"
export * from "./CurrentResidents.vue?vue&type=script&lang=js&"
import style0 from "./CurrentResidents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports